import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFan = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 100,
	viewBox: "0 0 100.0 100.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 50,
			cy: 50,
			rx: 50,
			ry: 50,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 30.0 4.5 L 97.0 33.0 M 30.0 95.5 L 97.0 67.0 M 42.28 36.55 A 15.0 3.0 49.48 0 1 49.75 49.9 A 15.0 3.0 49.48 0 1 37.72 40.45 A 15.0 3.0 49.48 0 1 30.25 27.1 A 15.0 3.0 49.48 0 1 42.28 36.55 Z M 37.7 59.73 A 15.0 3.0 -49.91 0 1 49.66 50.19 A 15.0 3.0 -49.91 0 1 42.3 63.6 A 15.0 3.0 -49.91 0 1 30.34 73.14 A 15.0 3.0 -49.91 0 1 37.7 59.73 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 65,
			cy: 50,
			rx: 15,
			ry: 3,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgFan;
